import { Route, RouteGroup } from '@billow/easy-route'

export default RouteGroup({

  middleware: ['auth', 'active-subscriber'],
  
  routes: [
    Route('/', 'dashboard', () => import('@/views/Dashboard.vue')),
    Route('/onboard', 'onboard', () => import('@/views/account/Onboard.vue')),
  ]
})